import { FloatingMenu } from "./FloatingMenu.js";
import DrawerMenu_module_default from "./DrawerMenu.module.js";
import { MenuContext } from "./MenuContext.js";
import { getPlatform } from "../../utils/platform.js";
import { DrawerMenu } from "./DrawerMenu.js";
import classNames from "classnames";
import { useEffect, useMemo, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Drawer } from "vaul";
import { Content, DropdownMenuItem, DropdownMenuPortal, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, Portal, Root, Trigger } from "@radix-ui/react-dropdown-menu";
//#region src/components/Menu/Menu.tsx
var DropdownMenuItemWrapper = ({ onSelect, children }) => /* @__PURE__ */ jsx(DropdownMenuItem, {
	onSelect: onSelect ?? void 0,
	asChild: true,
	children
});
/** Duration of the parent menu's slide-in animation (ms). */
var MENU_ANIMATION_DURATION = 180;
var DropdownSubMenuWrapper = ({ trigger, children, open: openProp, onOpenChange }) => {
	const [deferredOpen, setDeferredOpen] = useState(false);
	useEffect(() => {
		if (openProp) {
			const timer = setTimeout(() => setDeferredOpen(true), MENU_ANIMATION_DURATION);
			return () => clearTimeout(timer);
		} else setDeferredOpen(false);
	}, [openProp]);
	return /* @__PURE__ */ jsxs(DropdownMenuSub, {
		open: openProp ? deferredOpen : openProp,
		onOpenChange,
		children: [/* @__PURE__ */ jsx(DropdownMenuSubTrigger, {
			asChild: true,
			children: trigger
		}), /* @__PURE__ */ jsx(DropdownMenuPortal, { children: /* @__PURE__ */ jsx(DropdownMenuSubContent, {
			asChild: true,
			alignOffset: -20,
			children: /* @__PURE__ */ jsx(FloatingMenu, {
				title: "",
				showTitle: false,
				children
			})
		}) })]
	});
};
/**
* A menu opened by pressing a button.
*/
var Menu = ({ className, title, showTitle = true, open, onOpenChange, trigger, children: childrenProp, side = "bottom", align = "center" }) => {
	const platform = getPlatform();
	const drawer = platform === "android" || platform === "ios";
	const context = useMemo(() => ({
		MenuItemWrapper: drawer ? null : DropdownMenuItemWrapper,
		SubMenuWrapper: drawer ? null : DropdownSubMenuWrapper,
		onOpenChange
	}), [onOpenChange]);
	const children = /* @__PURE__ */ jsx(MenuContext.Provider, {
		value: context,
		children: childrenProp
	});
	return drawer ? /* @__PURE__ */ jsxs(Drawer.Root, {
		open,
		onOpenChange,
		children: [/* @__PURE__ */ jsx(Drawer.Trigger, {
			asChild: true,
			children: trigger
		}), /* @__PURE__ */ jsxs(Drawer.Portal, { children: [/* @__PURE__ */ jsx(Drawer.Overlay, { className: classNames(DrawerMenu_module_default.bg) }), /* @__PURE__ */ jsx(Drawer.Content, {
			asChild: true,
			children: /* @__PURE__ */ jsx(DrawerMenu, {
				title,
				children
			})
		})] })]
	}) : /* @__PURE__ */ jsxs(Root, {
		open,
		onOpenChange,
		children: [/* @__PURE__ */ jsx(Trigger, {
			asChild: true,
			children: trigger
		}), /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Content, {
			asChild: true,
			side,
			align,
			sideOffset: 8,
			children: /* @__PURE__ */ jsx(FloatingMenu, {
				className,
				title,
				showTitle,
				children
			})
		}) })]
	});
};
//#endregion
export { Menu };

//# sourceMappingURL=Menu.js.map